import { Injectable } from '@angular/core';
import {
  Rppk01DateGroup,
  Rppk01GateGroup,
  Rppk01Row,
  Rppk01TableResult,
  Rppk01Totals,
} from '../../models/report/rppk01.model';

@Injectable({ providedIn: 'root' })
export class MapperRppk01Service {
  mapTable(res: unknown): Rppk01TableResult {
    const raw = (res ?? {}) as Record<string, unknown>;
    const groups = (raw['groups'] ?? raw['Groups'] ?? []) as unknown[];
    return {
      siteName: String(raw['siteName'] ?? raw['SiteName'] ?? ''),
      siteAddress: String(raw['siteAddress'] ?? raw['SiteAddress'] ?? ''),
      siteTaxId: String(raw['siteTaxId'] ?? raw['SiteTaxId'] ?? ''),
      startDate: (raw['startDate'] ?? raw['StartDate'] ?? null) as string | null,
      endDate: (raw['endDate'] ?? raw['EndDate'] ?? null) as string | null,
      groups: groups.map((g) => this.mapGateGroup(g)),
      totals: this.mapTotals(raw['totals'] ?? raw['Totals'] ?? {}),
    };
  }

  private mapGateGroup(dto: unknown): Rppk01GateGroup {
    const g = (dto ?? {}) as Record<string, unknown>;
    const dateGroups = (g['dateGroups'] ?? g['DateGroups'] ?? []) as unknown[];
    return {
      gateName: String(g['gateName'] ?? g['GateName'] ?? ''),
      dateGroups: dateGroups.map((d) => this.mapDateGroup(d)),
      rowCount: Number(g['rowCount'] ?? g['RowCount'] ?? 0),
      sumParkingFee: Number(g['sumParkingFee'] ?? g['SumParkingFee'] ?? 0),
    };
  }

  private mapDateGroup(dto: unknown): Rppk01DateGroup {
    const d = (dto ?? {}) as Record<string, unknown>;
    const rows = (d['rows'] ?? d['Rows'] ?? []) as unknown[];
    return {
      entryDate: (d['entryDate'] ?? d['EntryDate'] ?? null) as string | null,
      rows: rows.map((r) => this.mapRow(r)),
    };
  }

  private mapRow(dto: unknown): Rppk01Row {
    const r = (dto ?? {}) as Record<string, unknown>;
    return {
      seq: Number(r['seq'] ?? r['Seq'] ?? 0),
      cardHolder: String(r['cardHolder'] ?? r['CardHolder'] ?? ''),
      parkingFee: Number(r['parkingFee'] ?? r['ParkingFee'] ?? 0),
      vehicleTypeName: String(r['vehicleTypeName'] ?? r['VehicleTypeName'] ?? ''),
      subscriptionName: String(r['subscriptionName'] ?? r['SubscriptionName'] ?? ''),
      entryLicense: String(r['entryLicense'] ?? r['EntryLicense'] ?? ''),
      entryDate: (r['entryDate'] ?? r['EntryDate'] ?? null) as string | null,
      exitDate: (r['exitDate'] ?? r['ExitDate'] ?? null) as string | null,
      durationText: String(r['durationText'] ?? r['DurationText'] ?? ''),
      entryGate: String(r['entryGate'] ?? r['EntryGate'] ?? ''),
      exitGate: String(r['exitGate'] ?? r['ExitGate'] ?? ''),
    };
  }

  private mapTotals(dto: unknown): Rppk01Totals {
    const t = (dto ?? {}) as Record<string, unknown>;
    return {
      rowCount: Number(t['rowCount'] ?? t['RowCount'] ?? 0),
      sumParkingFee: Number(t['sumParkingFee'] ?? t['SumParkingFee'] ?? 0),
    };
  }
}
